import { useMixpanel } from 'react-mixpanel-browser';
import { connect, useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import BrandOrdersContainer from '../blocks/BrandOrdersContainer';
import PageLayout from '../../components/common/PageLayout';
import { ordersReport } from '../../store/actions/brandOrders';
import DownloadReportModal from '../../components/modals/DownloadReportModal';
import CurrencyTypeSelectionModal from '../../components/modals/CurrencyTypeSelectionModal';
import { currencyTypeOptions } from '../../components/modals/CurrencyTypeSelectionModal/currencyTypeOptions';
import { reportBusinessActionToMixpanel } from '../../utils/reportBusinessActionToMixpanel';
import history from '../../utils/history';
import { OrdersPagePanel } from '../panels/OrdersPagePanel';
import { BrandOrdersActions } from '../../store/reducers/brandOrders';

function OrdersPageContainer(props) {
  const dispatch = useDispatch();
  const { modals } = useSelector((state) => state.brandOrders);
  const supplierId = useSelector((state) => state.role?.supplier?.id);
  const initialCurrencyTypeValue = currencyTypeOptions()[0].value;
  const [currentCheckedCurrencyValue, setCurrentCheckedCurrencyValue] = useState(initialCurrencyTypeValue);

  const handleCurrencyChange = (selectedValue) => {
    setCurrentCheckedCurrencyValue(selectedValue);
  };

  const mixpanel = useMixpanel();
  const reportBi = () => {
    reportBusinessActionToMixpanel(mixpanel, 'suppliers-orders-generate-report-button-click');
  };

  const downloadReport = () => {
    dispatch({ type: BrandOrdersActions.modals, payload: { currency: false } });
    props.downloadReport(currentCheckedCurrencyValue === initialCurrencyTypeValue);
    reportBi();
  };

  const onReportsPageLinkClick = () => {
    dispatch({ type: BrandOrdersActions.modals, payload: { report: false } });
    history.push(`/suppliers/${supplierId}/analytics/reports`);
  };

  const downloadReportModalText = [
    'Your orders report is being emailed to you and will',
    <br key="br" />,
    'soon be available on the ',
    <button key="reports-page-link" onClick={onReportsPageLinkClick}>
      Reports page
    </button>,
    '. ',
  ];

  return (
    <PageLayout top={<OrdersPagePanel onDownloadReport={downloadReport} />}>
      <DownloadReportModal
        open={modals.report}
        onClose={() => dispatch({ type: BrandOrdersActions.modals, payload: { report: false } })}
        text={downloadReportModalText}
      />
      <CurrencyTypeSelectionModal
        open={modals.currency}
        onClose={() => dispatch({ type: BrandOrdersActions.modals, payload: { currency: false } })}
        onConfirm={downloadReport}
        onChange={(selectedValue) => handleCurrencyChange(selectedValue)}
        currentCheckedValue={currentCheckedCurrencyValue}
        supplierCurrency={props.supplierCurrency}
      />
      <BrandOrdersContainer />
    </PageLayout>
  );
}

const mapStateToProps = (state) => {
  const supplierCurrency = state.role.supplier.currency;

  return {
    supplierCurrency,
  };
};

const mapDispatchToProps = (dispatch) => ({
  downloadReport: (useOriginalCurrency = true) => dispatch(ordersReport(useOriginalCurrency)),
});

export default connect(mapStateToProps, mapDispatchToProps)(OrdersPageContainer);

OrdersPageContainer.propTypes = {
  downloadReport: PropTypes.func.isRequired,
  supplierCurrency: PropTypes.string.isRequired,
};
